<template>
  <section>
    <div
      class="tw:flex tw:flex-col tw:gap-5 tw:md:gap-8 tw:w-full tw:lg:max-w-(--tw-breakpoint-landing) tw:md:max-w-[638px] tw:py-6 tw:lg:px-0 tw:mx-auto tw:lg:py-8"
    >
      <div class="tw:px-6 tw:md:px-0">
        <div class="tw:md:grid tw:md:grid-cols-2 tw:md:gap-8">
          <div
            class="tw:hidden tw:md:block tw:rounded-xl tw:border tw:border-black line-shadow tw:grow tw:h-[auto] plus_image tw:md:w-[294px]"
          />
          <div class="tw:text-center tw:md:text-left">
            <img
              :src="StudioPlusLogo"
              alt="Business Studio Plus"
              class="tw:max-h-[20px] tw:lg:max-h-[23px] tw:mx-auto tw:md:mx-0"
            />
            <h3
              class="tw:font-bold tw:text-xl tw:md:text-2xl tw:lg:text-[32px] tw:mt-4 tw:md:mt-2"
              v-html="$t('studio_plus_mp_subheader')"
            />
            <p class="tw:text-xs tw:md:text-sm tw:lg:text-[20px] tw:mt-2 tw:mb-4 tw:md:mb-0">
              {{ $t('studio_plus_mp_product_overview') }}
            </p>
          </div>
        </div>
        <img
          class="tw:md:hidden tw:w-full tw:md:h-[446px]"
          :src="cards[currentCardId].img"
          :alt="$t(cards[currentCardId].title)"
        />
      </div>
      <div class="tw:lg:max-w-(--tw-breakpoint-landing) tw:md:max-w-[638px] tw:mx-auto tw:md:mx-0">
        <StudioPlusBenefitsCardsMobile :cards="cards" @onCardChanged="setCurrentCard" />
        <StudioPlusBenefitsCards :cards="cards" />
      </div>
    </div>
  </section>
</template>
<script setup>
import { ref } from 'vue'

import StudioPlusBenefitsCardsMobile from '@/components/productPage/studioPlus/benefits/StudioPlusBenefitsCardsMobile.vue'
import StudioPlusBenefitsCards from '@/components/productPage/studioPlus/benefits/StudioPlusBenefitsCards.vue'
import rateInsightsImg from '@/assets/img/studio-plus-landing/benefits/plus_benefits_rate_insights.png'
import hotelOffersImg from '@/assets/img/studio-plus-landing/benefits/plus_benefits_hotel_offers.png'
import hotelConnectImg from '@/assets/img/studio-plus-landing/benefits/plus_benefits_hotel_connect.png'
import visitorsProfileImg from '@/assets/img/studio-plus-landing/benefits/plus_benefits_visitors_profile.png'
import hotelConnectVid from '@/assets/videos/studio-plus-landing/benefits/plus_benefits_hotel_connect.mp4'
import hotelOffersVid from '@/assets/videos/studio-plus-landing/benefits/plus_benefits_hotel_offers.mp4'
import visitorsProfileVid from '@/assets/videos/studio-plus-landing/benefits/plus_benefits_visitors_profile.mp4'
import rateInsightsVid from '@/assets/videos/studio-plus-landing/benefits/plus_benefits_rate_insights.mp4'

const StudioPlusLogo = new URL('/src/assets/img/landing/landing_studio_plus.svg', import.meta.url)

const HotelConnect = new URL('/src/assets/img/landing/icons/hotel_connect_icon.svg', import.meta.url)
const RateInsights = new URL('/src/assets/img/landing/icons/rate_insights_icon.svg', import.meta.url)
const VisitorsProfile = new URL('/src/assets/img/landing/icons/visitors_profile_icon.svg', import.meta.url)
const HotelOffers = new URL('/src/assets/img/landing/icons/hotel_offers_icon.svg', import.meta.url)

const cards = [
  {
    id: 0,
    title: 'hotel_offers_product_header',
    subtitle: 'tbs_mp_plus_benefits_4_text',
    benefits: ['studio_plus_mp_ho_point_1', 'studio_plus_mp_ho_point_2', 'studio_plus_mp_ho_point_3'],
    icon: HotelOffers,
    img: hotelOffersImg,
    vid: hotelOffersVid,
  },
  {
    id: 1,
    title: 'tbs_mp_plus_benefits_3',
    subtitle: 'tbs_mp_plus_benefits_3_text',
    benefits: ['plus_product_page_ri_point_1', 'plus_product_page_ri_point_2', 'plus_product_page_ri_point_3'],
    icon: RateInsights,
    img: rateInsightsImg,
    vid: rateInsightsVid,
  },
  {
    id: 2,
    title: 'tbs_mp_plus_benefits_1',
    subtitle: 'tbs_mp_plus_benefits_1_text',
    benefits: ['plus_product_page_hc_point_1', 'plus_product_page_hc_point_2', 'plus_product_page_hc_point_3'],
    icon: HotelConnect,
    img: hotelConnectImg,
    vid: hotelConnectVid,
  },
  {
    id: 3,
    title: 'tbs_mp_plus_benefits_2',
    subtitle: 'tbs_mp_plus_benefits_2_text',
    benefits: ['plus_product_page_vp_point_1', 'plus_product_page_vp_point_2', 'plus_product_page_vp_point_3'],
    icon: VisitorsProfile,
    img: visitorsProfileImg,
    vid: visitorsProfileVid,
  },
]

const currentCardId = ref(0)

const setCurrentCard = ({ id }) => {
  if (id === undefined || id === null) return
  currentCardId.value = id
}
</script>
<style scoped>
.line-shadow {
  box-shadow: 3px 3px 0px 0px #000;
}

.plus_image {
  background-image: url('../../../assets/img/studio-plus-landing/studio_plus_img.jpg');
  background-size: cover;
  background-position: center;
  width: 100%;
}
</style>
